export * from './ngx-geoautocomplete.module';
